
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/komodo-defi-framework/setup/configure-mm2-json",
      function () {
        return require("private-next-pages/docs/komodo-defi-framework/setup/configure-mm2-json/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/komodo-defi-framework/setup/configure-mm2-json"])
      });
    }
  